import { useTranslation } from "react-i18next";
import { Input } from "ui";

import { useDebouncedInput, parseNullableString } from "./useDebouncedInput";
import { VideoUrlPreview } from "./VideoUrlPreview";

interface FreestyleMediaFieldProps {
  workoutItemId: string;
  videoUrl: string | null;
  video: { url: string; key: string } | null;
  onVideoUrlChange: (value: string | null) => void;
}

export function FreestyleMediaField(props: FreestyleMediaFieldProps) {
  const { t } = useTranslation();
  const { localValue, handleChange } = useDebouncedInput({
    initialValue: props.videoUrl ?? "",
    onChange: props.onVideoUrlChange,
    transform: parseNullableString,
  });

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-1">
        <label className="text-xs font-medium text-slate-500">
          {t("editWorkout.mediaUrl")}
        </label>
        <Input
          type="url"
          value={localValue}
          onChange={handleChange}
          placeholder={t("editWorkout.mediaUrlPlaceholder")}
          className="h-8 text-sm bg-white/80 border-slate-200"
        />
      </div>

      {props.video?.url ? (
        <div className="rounded-lg overflow-hidden border border-slate-200">
          <video
            src={props.video.url}
            controls
            className="w-full max-h-[200px] object-contain bg-black/5"
          />
        </div>
      ) : null}

      {props.videoUrl && !props.video?.url ? (
        <VideoUrlPreview url={props.videoUrl} />
      ) : null}
    </div>
  );
}
